<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      :show-save-button="$permission.canEdit()"
      unit="用户"
      edit-title
      id-key="UserId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      close-on-saved
      @save-create="onSaved"
      @closed="isEdit = false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <!-- <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="用户类别" prop="UserType">
              <el-select size="mini" v-model="data.UserType" placeholder="请选择用户类别" :disabled="data.DataSource==1" clearable>
                <el-option label="平台" :value="0"></el-option>
                <el-option label="商家" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12" v-if="data.UserType==1">
            <el-form-item label="所属商家" prop="StoreId" :rules="data.UserType==1?typeRules.StoreId:null">
              <busi-select v-model="data.StoreId" ref="busiSelect" :disabled="data.DataSource==1" :checkState="checkState"></busi-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="用户姓名" prop="UserName">
              <el-input
                v-model="data.UserName"
                placeholder="请输入用户姓名"
                :disabled="data.DataSource == 1"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="所属角色" prop="RoleId">
              <role-select
                v-model="data.RoleId"
                ref="roleSelect"
                :disabled="data.DataSource == 1"
              ></role-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="登录账号" prop="LoginId">
              <el-input
                v-model="data.LoginId"
                placeholder="请输入登录账号"
                :disabled="data.DataSource == 1"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item
              label="初始密码"
              prop="Pwd"
              :rules="isEdit ? null : pwdRules.Pwd"
            >
              <el-input
                show-password
                type="password"
                v-model="data.Pwd"
                :placeholder="isEdit ? '如无需改动可不填' : '请输入用户密码'"
                :disabled="data.DataSource == 1"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import roleSelect from "@/components/sys/role/select";
import storeSelect from "@/components/shop/store/select";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    roleSelect,
    storeSelect,
    busiSelect,
  },
  data() {
    return {
      data: {
        UserId: 0,
        UserName: "", //用户姓名
        LoginId: "", //登录账号
        Pwd: "", //初始密码
        // DpId: null,
        // DpName: "", //部门名称
        Mobile: "", //手机号码
        IdCard: "",
        Status: 1, //状态
        RoleId: null, //所属角色
        RoleName: "",
        UserType: 0,
        StoreId: null, //所属商家
        DataSource: 0, //来源 0平台添加，1小程序申请
      },
      isEdit: false,
      api: require("@/api/sy/user").default,
      rules: {
        UserName: [{ required: true, message: "用户姓名不能为空" }],
        LoginId: [{ required: true, message: "登录账号不能为空" }],
        RoleId: [{ required: true, message: "请选择所属角色" }],
        //UserType: [{ required: true, message: "请选择用户类别" }],
        // Pwd: [{ validator: this.$commonJs.validateRules.validPwd }],
      },
      pwdRules: {
        Pwd: [
          { required: true, message: "初始密码不能为空" },
          // { validator: this.$commonJs.validateRules.validPwd },
        ],
      },
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属商家" }],
      },
      roleType: 1,
      checkState: 2,
    };
  },
  methods: {
    onEditOpened(data) {
      console.log(data, "data");
      this.isEdit = true;
      this.data.Pwd = "";
      this.roleType = data.UserType;
    },
    openDpDialog() {
      this.$refs.dpDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    onSaved() {
      this.$refs.dialog.reset();
      this.$refs.dialog.isSaved = true;
    },
  },
};
</script>